
import Vue from 'vue'
import Footer from '@/components/Footer.vue';

export default Vue.extend({
    name: 'MainLayout',
    components: {
        Footer
    },
    data() {
        return {
            showNavigationDrawer: false,
            list: [
                { label: "Home", to: "/", target: ''},
                // { label: "Use Cases", to: "/#use-cases", target: ''},
                // { label: "Workspace", to: "/#workspace", target: ''},
                { label: "Resource Center", to: "/blog?contentId=", target: ''},
                { label: "Docs", to: "https://docs.helperai.ai", target: '_blank'}
            ],
            contentInfoList: [
                {
                    id: null as unknown as string,
                    title: null as unknown as string,
                    heroImageUrl: null as unknown as string
                }
            ],
        };
    },
    computed: {
        typeFormUrl() {
            return process.env.VUE_APP_TYPEFORM_URL;
        },
    },
    methods: {
        async getContents() {
            let contentData
            
            try{
                contentData = await this.api$.contentfulApi.entries();
            }catch (error) {
                console.error(error)
            }
            
            interface ContentsItem {
                id:  string,
                title:  string,
                heroImageUrl:  string
            };
            let contents: ContentsItem[] =[]

            contentData.data.items!.forEach( (item) => {
                const contentsItem: ContentsItem = {
                    id: item.sys?.id as string,
                    title: item.fields?.title as string,
                    heroImageUrl: '' as string
                }

                this.api$.contentfulApi.asset(item.fields?.heroImage?.sys?.id as string)
                    .then(resp => {
                        contentsItem.heroImageUrl = resp.data.fields?.file.url
                    }).catch( (error) => {
                        console.error(error)
                    })
                contents.push(contentsItem)      
            })
            this.contentInfoList = contents

            this.list.map((item) => {
                if (item.label === "Resource Center") {
                    if( this.contentInfoList.length > 0 ){
                        item.to = '/blog?contentId='+this.contentInfoList[0].id
                    }
                    else {
                        item.to = ''
                    }
                }
                return item;
            });
        },
    },
    created() {
        this.getContents();
    },
})
